module.exports = __webpack_public_path__ + "img/checked.d76b249a.svg";